<ion-header>
  <ion-row class="ion-justify-content-between ion-align-items-center">
    <div class="column">
      <div class="back" (click)="back()">
        <img src="./assets/icon/back.svg" alt="" />
      </div>
      <div class="logo">{{ 'manual.title' | translate }}</div>
    </div>
  </ion-row>
</ion-header>

<ion-content>
  <div class="manual-content">
    <p><img class="logo" title="" src="./assets/manual/image17.png" alt="" /></p>
    <p>{{ 'manual.body.block001' | translate }}</p>
    <p>{{ 'manual.body.block002' | translate }}</p>
    <ol start="1">
      <li>{{ 'manual.body.block003' | translate }}</li>
      <li>{{ 'manual.body.block004' | translate }}</li>
      <li>{{ 'manual.body.block005' | translate }}</li>
      <li>{{ 'manual.body.block006' | translate }}</li>
      <li>{{ 'manual.body.block007' | translate }}</li>
      <li [innerHTML]="'manual.body.block008' | translate"></li>
    </ol>
    <p>{{ 'manual.body.block009' | translate }}</p>
    <p>{{ 'manual.body.block010' | translate }}</p>
    <h1>{{ 'manual.body.block011' | translate }}</h1>
    <table>
      <tbody>
        <tr>
          <td colspan="1" rowspan="1">
            <p>{{ 'manual.body.block012' | translate }}</p>
          </td>
          <td colspan="1" rowspan="1">
            <p>{{ 'manual.body.block013' | translate }}</p>
          </td>
        </tr>
        <tr>
          <td colspan="1" rowspan="1">
            <p>{{ 'manual.body.block014' | translate }}</p>
          </td>
          <td colspan="1" rowspan="1">
            <p>{{ 'manual.body.block015' | translate }}</p>
          </td>
        </tr>
        <tr>
          <td colspan="1" rowspan="1">
            <p>{{ 'manual.body.block016' | translate }}</p>
          </td>
          <td colspan="1" rowspan="1">
            <p>{{ 'manual.body.block017' | translate }}</p>
          </td>
        </tr>
        <tr>
          <td colspan="1" rowspan="1">
            <p>{{ 'manual.body.block018' | translate }}</p>
          </td>
          <td colspan="1" rowspan="1">
            <p>{{ 'manual.body.block019' | translate }}</p>
          </td>
        </tr>
        <tr>
          <td colspan="1" rowspan="1">
            <p>{{ 'manual.body.block020' | translate }}</p>
          </td>
          <td colspan="1" rowspan="1">
            <p>{{ 'manual.body.block021' | translate }}</p>
          </td>
        </tr>
        <tr>
          <td colspan="1" rowspan="1">
            <p>{{ 'manual.body.block022' | translate }}</p>
          </td>
          <td colspan="1" rowspan="1">
            <p>{{ 'manual.body.block023' | translate }}</p>
          </td>
        </tr>
      </tbody>
    </table>
    <p><br /><br /></p>
    <h1>{{ 'manual.body.block024' | translate }}</h1>
    <p>{{ 'manual.body.block025' | translate }}</p>
    <p [innerHTML]="'manual.body.block026' | translate"></p>
    <p [innerHTML]="'manual.body.block027' | translate"></p>
    <h1>{{ 'manual.body.block028' | translate }}</h1>
    <p>{{ 'manual.body.block029' | translate }}</p>
    <p [innerHTML]="'manual.body.block030' | translate"></p>
    <h2>{{ 'manual.body.block031' | translate }}</h2>
    <p [innerHTML]="'manual.body.block032' | translate"></p>
    <p><img title="" src="./assets/manual/image6.png" alt="" /></p>
    <p>{{ 'manual.body.block033' | translate }}</p>
    <p [innerHTML]="'manual.body.block034' | translate"></p>
    <table>
      <tbody>
        <tr>
          <td colspan="1" rowspan="1">
            <p>{{ 'manual.body.block035' | translate }}</p>
          </td>
          <td colspan="1" rowspan="1">
            <p>{{ 'manual.body.block036' | translate }}</p>
          </td>
          <td colspan="1" rowspan="1">
            <p>{{ 'manual.body.block037' | translate }}</p>
          </td>
        </tr>
        <tr>
          <td colspan="1" rowspan="1">
            <p>{{ 'manual.body.block038' | translate }}</p>
          </td>
          <td colspan="1" rowspan="1">
            <p>{{ 'manual.body.block039' | translate }}</p>
          </td>
          <td colspan="1" rowspan="1">
            <p>{{ 'manual.body.block040' | translate }}</p>
          </td>
        </tr>
        <tr>
          <td colspan="1" rowspan="1">
            <p>{{ 'manual.body.block041' | translate }}</p>
          </td>
          <td colspan="1" rowspan="1">
            <p>{{ 'manual.body.block042' | translate }}</p>
          </td>
          <td colspan="1" rowspan="1">
            <p>{{ 'manual.body.block043' | translate }}</p>
          </td>
        </tr>
        <tr>
          <td colspan="1" rowspan="1">
            <p>{{ 'manual.body.block044' | translate }}</p>
          </td>
          <td colspan="1" rowspan="1">
            <p>{{ 'manual.body.block045' | translate }}</p>
          </td>
          <td colspan="1" rowspan="1">
            <p>{{ 'manual.body.block046' | translate }}</p>
          </td>
        </tr>
        <tr>
          <td colspan="1" rowspan="1">
            <p>{{ 'manual.body.block047' | translate }}</p>
          </td>
          <td colspan="1" rowspan="1">
            <p>{{ 'manual.body.block048' | translate }}</p>
          </td>
          <td colspan="1" rowspan="1">
            <p>{{ 'manual.body.block049' | translate }}</p>
          </td>
        </tr>
        <tr>
          <td colspan="1" rowspan="1">
            <p [innerHTML]="'manual.body.block050' | translate"></p>
          </td>
          <td colspan="1" rowspan="1">
            <p [innerHTML]="'manual.body.block051' | translate"></p>
          </td>
          <td colspan="1" rowspan="1">
            <p>{{ 'manual.body.block052' | translate }}</p>
          </td>
        </tr>
        <tr>
          <td colspan="1" rowspan="1">
            <p>{{ 'manual.body.block053' | translate }}</p>
          </td>
          <td colspan="1" rowspan="1">
            <p>{{ 'manual.body.block054' | translate }}</p>
          </td>
          <td colspan="1" rowspan="1">
            <p>{{ 'manual.body.block055' | translate }}</p>
          </td>
        </tr>
        <tr>
          <td colspan="1" rowspan="1">
            <p>{{ 'manual.body.block056' | translate }}</p>
          </td>
          <td colspan="1" rowspan="1">
            <p>{{ 'manual.body.block057' | translate }}</p>
          </td>
          <td colspan="1" rowspan="1">
            <p>{{ 'manual.body.block058' | translate }}</p>
          </td>
        </tr>
        <tr>
          <td colspan="1" rowspan="1">
            <p>{{ 'manual.body.block059' | translate }}</p>
          </td>
          <td colspan="1" rowspan="1">
            <p>{{ 'manual.body.block060' | translate }}</p>
          </td>
          <td colspan="1" rowspan="1">
            <p>{{ 'manual.body.block061' | translate }}</p>
          </td>
        </tr>
        <tr>
          <td colspan="1" rowspan="1">
            <p>{{ 'manual.body.block062' | translate }}</p>
          </td>
          <td colspan="1" rowspan="1">
            <p>{{ 'manual.body.block063' | translate }}</p>
          </td>
          <td colspan="1" rowspan="1">
            <p>{{ 'manual.body.block064' | translate }}</p>
          </td>
        </tr>
        <tr>
          <td colspan="1" rowspan="1">
            <p>{{ 'manual.body.block065' | translate }}</p>
          </td>
          <td colspan="1" rowspan="1">
            <p>{{ 'manual.body.block066' | translate }}</p>
          </td>
          <td colspan="1" rowspan="1">
            <p>{{ 'manual.body.block067' | translate }}</p>
          </td>
        </tr>
      </tbody>
    </table>
    <h2>{{ 'manual.body.block068' | translate }}</h2>
    <p>{{ 'manual.body.block069' | translate }}</p>
    <p><img title="" src="./assets/manual/image11.png" alt="" /></p>
    <p>{{ 'manual.body.block070' | translate }}</p>
    <p>{{ 'manual.body.block071' | translate }}</p>
    <p>{{ 'manual.body.block072' | translate }}</p>
    <p>{{ 'manual.body.block073' | translate }}</p>
    <p [innerHTML]="'manual.body.block074' | translate"></p>
    <p>{{ 'manual.body.block075' | translate }}</p>
    <h2>{{ 'manual.body.block076' | translate }}</h2>
    <p>{{ 'manual.body.block077' | translate }}</p>
    <p>{{ 'manual.body.block078' | translate }}</p>
    <p [innerHTML]="'manual.body.block079' | translate"></p>
    <p>{{ 'manual.body.block080' | translate }}</p>
    <p>{{ 'manual.body.block0801' | translate }}</p>
    <p><img title="" src="./assets/manual/image11_stock_explain.png" alt="" /></p>
    <p>{{ 'manual.body.block0802' | translate }}</p>
    <p><img title="" src="./assets/manual/image11_prediction.png" alt="" /></p>
    <p></p>
    <p [innerHTML]="'manual.body.block081' | translate"></p>
    <p><img title="" src="./assets/manual/image4.png" alt="" /></p>
    <p>{{ 'manual.body.block082' | translate }}</p>
    <p [innerHTML]="'manual.body.block083' | translate"></p>
    <p><img title="" src="./assets/manual/image8.png" alt="" /></p>
    <p>{{ 'manual.body.block084' | translate }}</p>
    <p>{{ 'manual.body.block085' | translate }}</p>
    <p><img title="" src="./assets/manual/image15.png" alt="" /></p>
    <p [innerHTML]="'manual.body.block086' | translate"></p>
    <ul>
      <li>{{ 'manual.body.block087' | translate }}</li>
      <li [innerHTML]="'manual.body.block088' | translate"></li>
      <li [innerHTML]="'manual.body.block089' | translate"></li>
      <li [innerHTML]="'manual.body.block090' | translate"></li>
      <li>{{ 'manual.body.block091' | translate }}</li>
    </ul>
    <p>{{ 'manual.body.block092' | translate }}</p>
    <p><img title="" src="./assets/manual/image13.png" alt="" /></p>
    <p [innerHTML]="'manual.body.block093' | translate"></p>
    <p>{{ 'manual.body.block094' | translate }}</p>
    <p><img title="" src="./assets/manual/image18.png" alt="" /></p>
    <h2>{{ 'manual.body.block095' | translate }}</h2>
    <p>{{ 'manual.body.block096' | translate }}</p>
    <p [innerHTML]="'manual.body.block097' | translate"></p>
    <p><img title="" src="./assets/manual/image1.png" alt="" /></p>
    <p>{{ 'manual.body.block098' | translate }}</p>
    <p>{{ 'manual.body.block099' | translate }}</p>
    <p>
      <img title="" src="./assets/manual/image5.png" alt="" /><img
        title=""
        src="./assets/manual/image3.png"
        alt=""
      />
    </p>
    <p>{{ 'manual.body.block100' | translate }}</p>
    <p>
      <img title="" src="./assets/manual/image12.png" alt="" /><img
        title=""
        src="./assets/manual/image7.png"
        alt=""
      />
    </p>
    <p>{{ 'manual.body.block101' | translate }}</p>
    <p>
      <img title="" src="./assets/manual/image2.png" alt="" /><img
        title=""
        src="./assets/manual/image16.png"
        alt=""
      />
    </p>
    <h1>{{ 'manual.body.block102' | translate }}</h1>
    <p [innerHTML]="'manual.body.block103' | translate"></p>
    <p>{{ 'manual.body.block104' | translate }}</p>
    <p>{{ 'manual.body.block105' | translate }}</p>
    <h2>{{ 'manual.body.block106' | translate }}</h2>
    <p [innerHTML]="'manual.body.block107' | translate"></p>
    <p><img title="" src="./assets/manual/image10.png" alt="" /></p>
    <p [innerHTML]="'manual.body.block108' | translate"></p>
    <p><img title="" src="./assets/manual/image14.png" alt="" /></p>
    <p>{{ 'manual.body.block109' | translate }}</p>
    <h2>{{ 'manual.body.block110' | translate }}</h2>
    <p>{{ 'manual.body.block111' | translate }}</p>
    <p><img title="" src="./assets/manual/image19.png" alt="" /></p>
    <p class="center" [innerHTML]="'manual.body.block112' | translate"></p>
    <p class="center">{{ 'manual.body.block113' | translate }}</p>
    <p class="center" [innerHTML]="'manual.body.block114' | translate"></p>
    <p class="center">{{ 'manual.body.block115' | translate }}</p>
    <p class="center" [innerHTML]="'manual.body.block116' | translate"></p>
    <p class="center">{{ 'manual.body.block117' | translate }}</p>
    <p class="center">{{ 'manual.body.block118' | translate }}</p>
    <div class="footer">
      <p class="center" [innerHTML]="'manual.body.block119' | translate"></p>
      <p class="center">{{ 'manual.body.block120' | translate }}</p>
    </div>
  </div>
</ion-content>
